<template>
    <div class="com-left-content text-white">
        <div>
            <BlockBox title="市级指标体系" enTitle="City-level Indicator System" height="166">
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="flex align-center justify-between text-center">
                            <div class="indicatorItem">
                                <div class="indicatorCircle">
                                    <div class="indicatorNum text-color-blue">{{item.count || '-'}}</div>
                                </div>
                                <div class="base-font-14 margin-top-10">指标体系</div>
                            </div>
                            <div class="indicatorItem">
                                <div class="indicatorCircle">
                                    <div class="indicatorNum text-color-green">{{item.indexCount || '-'}}</div>
                                </div>
                                <div class="base-font-14 margin-top-10">关注维度</div>
                            </div>
                            <div class="indicatorItem">
                                <div class="indicatorCircle">
                                    <div class="indicatorNum text-color-orange">{{item.secondIndexCount || '-'}}</div>
                                </div>
                                <div class="base-font-14 margin-top-10">关注指标</div>
                            </div>
                            <div class="indicatorItem">
                                <div class="indicatorCircle">
                                    <div class="indicatorNum text-color-yellow">{{item.itemCount || '-'}}</div>
                                </div>
                                <div class="base-font-14 margin-top-10">行为锚点</div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="&quot;六个一&quot;指标参与情况" enTitle="Six-One Participation" height="246">
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="participationTable">
                            <div class="tableHeader flex align-center">
                                <div class="col-school">学校名称</div>
                                <div class="col-num">学生人数</div>
                                <div class="col-rate">参与率</div>
                            </div>
                            <div class="tableBody">
                                <div class="tableRow flex align-center" v-for="(row, index) in schoolDataList" :key="index">
                                    <div class="col-school ellipsis">{{row.schoolName}}</div>
                                    <div class="col-num">{{row.studentCount}}</div>
                                    <div class="col-rate">{{row.useRate}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="市级指标行为占比" enTitle="Behavior Proportion" height="246">
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="behaviorChartWrap flex align-center">
                            <div id="chartBehaviorPie" style="height:220px;flex:1;"></div>
                            <div class="behaviorLegend">
                                <div class="legendItem flex align-center" v-for="(item, index) in indexList" :key="index">
                                    <span class="legendColor" :style="'background:' + colors[index]"></span>
                                    <span class="legendName">{{item.name}} {{item.value}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
        
        <div class="margin-top-15">
            <BlockBox title="市级评价最新动态" enTitle="Latest Evaluation" height="266">
                <template #content>
                    <div style="padding:10px 15px;box-sizing: border-box">
                        <div class="latestList">
                            <div class="listHeader flex align-center">
                                <div class="col-school">学校</div>
                                <div class="col-student">学生</div>
                                <div class="col-behavior">行为</div>
                                <div class="col-time">时间</div>
                            </div>
                            <div class="scrollWrapper">
                                <div class="scrollContent" :style="'animation-duration:' + scrollDuration + 's'">
                                    <div class="listRow flex align-center" v-for="(row, index) in recordList" :key="'scroll-' + index">
                                        <div class="col-school ellipsis">{{row.schoolName}}</div>
                                        <div class="col-student ellipsis">{{row.studentName}}</div>
                                        <div class="col-behavior ellipsis">{{row.itemName}}</div>
                                        <div class="col-time">{{row.createTime}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox'
    import { cityLeftData } from "@/api/api";
    
    export default {
        name: "cityLeftContent",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                item: {},
                schoolDataList: [],
                indexList: [],
                recordList: [],
                timerLeft: null,
                colors: ['#f0792a', '#4b3eeb', '#247bf1', '#67e591', '#05d3f8', '#c0f02a'],
                scrollDuration: 15,
            }
        },
        mounted() {
            this.changeData();
            this.timerLeft = setTimeout(() => {
                this.changeData();
            }, 60000);
        },
        beforeDestroy() {
            clearTimeout(this.timerLeft);
        },
        methods: {
            async changeData() {
                try {
                    const res = await cityLeftData();
                    if (res && res.data) {
                        this.item = res.data;
                        if (res.data.schoolDataList) {
                            this.schoolDataList = res.data.schoolDataList;
                        }
                        if (res.data.indexList) {
                            this.indexList = res.data.indexList;
                        }
                        if (res.data.recordList) {
                            this.recordList = res.data.recordList;
                        }
                    }
                } catch (e) {
                    console.log('使用默认数据');
                }
                this.$nextTick(() => {
                    this.drawBehaviorPie();
                });
            },
            drawBehaviorPie() {
				console.log(echarts)
                this.chart = this.$echarts.init(document.getElementById("chartBehaviorPie"));
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b}: {c}%'
                    },
                    series: [{
                        name: '行为占比',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ['40%', '50%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 5,
                            borderColor: '#0a1a3a',
                            borderWidth: 2
                        },
                        label: {
                            show: false
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold',
                                color: '#fff'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.indexList,
                        color: this.colors
                    }]
                };
                this.chart.setOption(option);
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            }
        }
    }
</script>

<style lang="scss">
    .com-left-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;

        .indicatorItem {
            .indicatorCircle {
                width: 70px;
                height: 70px;
                border-radius: 50%;
                background: radial-gradient(circle, rgba(30, 80, 150, 0.8) 0%, rgba(10, 30, 60, 0.6) 100%);
                border: 2px solid rgba(100, 180, 255, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto;
                position: relative;
                animation: energyPulse 3s ease-in-out infinite;

                &::before {
                    content: '';
                    position: absolute;
                    top: -8px;
                    left: -8px;
                    right: -8px;
                    bottom: -8px;
                    border-radius: 50%;
                    border: 1px solid rgba(100, 180, 255, 0.3);
                    animation: energyRing 3s ease-in-out infinite;
                }

                &::after {
                    content: '';
                    position: absolute;
                    top: -15px;
                    left: -15px;
                    right: -15px;
                    bottom: -15px;
                    border-radius: 50%;
                    border: 1px solid rgba(100, 180, 255, 0.15);
                    animation: energyRing 3s ease-in-out infinite 0.5s;
                }

                .indicatorNum {
                    font-size: 28px;
                    font-weight: bold;
                }
            }
        }

        @keyframes energyPulse {
            0%, 100% {
                box-shadow: 0 0 15px rgba(50, 120, 200, 0.4), 0 0 30px rgba(50, 120, 200, 0.2);
                opacity: 0.85;
            }
            50% {
                box-shadow: 0 0 25px rgba(50, 120, 200, 0.7), 0 0 50px rgba(50, 120, 200, 0.4), 0 0 70px rgba(50, 120, 200, 0.2);
                opacity: 1;
            }
        }

        @keyframes energyRing {
            0%, 100% {
                transform: scale(1);
                opacity: 0.3;
            }
            50% {
                transform: scale(1.1);
                opacity: 0.6;
            }
        }

        .behaviorChartWrap {
            .behaviorLegend {
                width: 140px;
                padding-left: 10px;

                .legendItem {
                    margin-bottom: 8px;

                    .legendColor {
                        width: 10px;
                        height: 10px;
                        border-radius: 2px;
                        margin-right: 8px;
                        flex-shrink: 0;
                    }

                    .legendName {
                        flex: 1;
                        font-size: 12px;
                        color: rgba(255, 255, 255, 0.7);
                    }
                }
            }
        }

        .participationTable {
            .tableHeader {
                height: 32px;
                background: rgba(20, 60, 120, 0.5);
                border-radius: 4px;
                font-weight: bold;
                font-size: 13px;
                color: #8df2ff;
                padding: 0 5px;

                .col-school {
                    flex: 2;
                }

                .col-num {
                    flex: 1;
                    text-align: center;
                }

                .col-rate {
                    flex: 1;
                    text-align: right;
                }
            }

            .tableBody {
                max-height: 170px;
                overflow-y: auto;

                &::-webkit-scrollbar {
                    width: 3px;
                }

                &::-webkit-scrollbar-thumb {
                    background: rgba(45, 163, 255, 0.5);
                    border-radius: 3px;
                }

                .tableRow {
                    height: 30px;
                    font-size: 12px;
                    border-bottom: 1px solid rgba(45, 163, 255, 0.1);
                    padding: 0 5px;
                    color: rgba(255, 255, 255, 0.8);

                    .col-school {
                        flex: 2;
                    }

                    .col-num {
                        flex: 1;
                        text-align: center;
                    }

                    .col-rate {
                        flex: 1;
                        text-align: right;
                        color: #67e591;
                    }

                    &:hover {
                        background: rgba(20, 60, 120, 0.3);
                    }
                }
            }
        }

        .latestList {
            .listHeader {
                height: 30px;
                background: rgba(20, 60, 120, 0.5);
                border-radius: 4px;
                font-weight: bold;
                font-size: 12px;
                color: #8df2ff;
                padding: 0 5px;

                .col-school {
                    flex: 2;
                }

                .col-student {
                    flex: 1.5;
                }

                .col-behavior {
                    flex: 1.5;
                }

                .col-time {
                    flex: 2;
                    text-align: right;
                }
            }

            .scrollWrapper {
                height: 170px;
                overflow: hidden;
                position: relative;

                .scrollContent {
                    animation: scrollUp linear infinite;

                    .listRow {
                        height: 28px;
                        font-size: 11px;
                        border-bottom: 1px solid rgba(45, 163, 255, 0.1);
                        padding: 0 5px;
                        color: rgba(255, 255, 255, 0.7);

                        .col-school {
                            flex: 2;
                        }

                        .col-student {
                            flex: 1.5;
                        }

                        .col-behavior {
                            flex: 1.5;
                        }

                        .col-time {
                            flex: 2;
                            text-align: right;
                        }

                        &:hover {
                            background: rgba(20, 60, 120, 0.3);
                        }
                    }
                }
            }
        }

        @keyframes scrollUp {
            0% {
                transform: translateY(0);
            }
            100% {
                transform: translateY(-50%);
            }
        }
    }
</style>
